import { track } from 'lib/babylistHealthAnalytics'
import { decorateEventPayload } from './decorateEventPayload'

export const emailCaptureViewedEvent = (tracker: any) => () => {
  const payload = decorateEventPayload({ event: track.emailCaptureViewed })
  tracker.trackEvent(payload)
}
